// extracted by mini-css-extract-plugin
export default {"preloader":"task__task-right-menu__components__task-preloader__preloader"};